import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import { LocaleContext } from '../../../contexts/LocaleContext';
import Button, { ButtonColor, ButtonSize } from '../../../atoms/buttons/Button';
import ServiceFooterAccordion from '../common/ServiceFooterAccordion';
import ServiceFooterLogo from '../common/ServiceFooterLogo';
import ServiceFooterSectionBody from '../common/ServiceFooterSectionBody';
import ServiceFooterSingleHeadingAccordion from '../common/ServiceFooterSingleHeadingAccordion';
import css from './ServiceFooter.module.scss';

const ServiceFooter: React.FC = () => {
  const intl = useIntl();

  const localeCtx = useContext(LocaleContext);
  const intlPref = 'components.common.layouts.globalFooter.serviceFooter.';

  return (
    <div className={css.ServiceFooter}>
      <div className={css.ServiceFooter__Inner}>
        <div className={css.ServiceFooter__LinkSection}>
          <ServiceFooterLogo />
          <Button
            buttonSize={ButtonSize.Medium}
            buttonColor={ButtonColor.Biz}
            className_Deprecated={css.ServiceFooter__Button}
            href="https://stores.jp/reserve"
          >
            {intl.formatMessage({ id: intlPref + 'buttons.startTrial' })}
          </Button>
        </div>
        <ServiceFooterAccordion
          className={css.ServiceFooter__ContentSection}
          name="footer-business"
          copy={intl.formatMessage({ id: intlPref + 'copies.business' })}
        >
          <ServiceFooterSectionBody
            rows={[
              {
                heading: intl.formatMessage({
                  id: intlPref + 'headings.service',
                }),
                links: [
                  {
                    url: 'https://stores.jp/reserve',
                    text: intl.formatMessage({
                      id: intlPref + 'links.business',
                    }),
                  },
                  {
                    url: '/inquiry',
                    text: intl.formatMessage({
                      id: intlPref + 'links.inquiry',
                    }),
                  },
                  {
                    url: 'https://go.coubic.com/doc_feature.html',
                    text: intl.formatMessage({
                      id: intlPref + 'links.requestDoc',
                    }),
                  },
                  {
                    url: 'https://go.coubic.com/movie_demo.html',
                    text: intl.formatMessage({
                      id: intlPref + 'links.demoMovie',
                    }),
                  },
                  {
                    url: 'https://stores.jp/reserve/features',
                    text: intl.formatMessage({
                      id: intlPref + 'links.features',
                    }),
                  },
                  {
                    url: 'https://stores.jp/reserve/advantages',
                    text: intl.formatMessage({
                      id: intlPref + 'links.advantages',
                    }),
                  },
                  {
                    url: 'https://stores.jp/reserve/integrations',
                    text: intl.formatMessage({
                      id: intlPref + 'links.integrations',
                    }),
                  },
                  {
                    url: 'https://stores.jp/reserve/cases',
                    text: intl.formatMessage({
                      id: intlPref + 'links.cases',
                    }),
                  },
                  {
                    url: 'https://stores.jp/reserve/pricing',
                    text: intl.formatMessage({
                      id: intlPref + 'links.pricing',
                    }),
                  },
                  {
                    url: 'https://stores.jp/reserve/faq',
                    text: intl.formatMessage({
                      id: intlPref + 'links.faq',
                    }),
                  },
                  // # リソース不足のため一時的にクローズする see: https://github.com/heyinc/rsv-issues/issues/16266
                  // {
                  //   url: '/partnership/become_partner',
                  //   text: intl.formatMessage({
                  //     id: intlPref + 'links.partners',
                  //   }),
                  // },
                ],
              },
              {
                heading: intl.formatMessage({
                  id: intlPref + 'headings.bizCategory',
                }),
                links: [
                  // TODO: merchant_categoryがpath情報もってない
                  {
                    url: 'https://stores.jp/reserve/categories/yoga',
                    text: intl.formatMessage({
                      id: intlPref + 'links.yoga',
                    }),
                  },
                  {
                    url: 'https://stores.jp/reserve/categories/massage_salons',
                    text: intl.formatMessage({
                      id: intlPref + 'links.massage',
                    }),
                  },
                  {
                    url: 'https://stores.jp/reserve/categories/fitness_school',
                    text: intl.formatMessage({
                      id: intlPref + 'links.fitness_school',
                    }),
                  },
                  {
                    url: 'https://stores.jp/reserve/categories/online_lessons',
                    text: intl.formatMessage({
                      id: intlPref + 'links.online_lessons',
                    }),
                  },
                  {
                    url: 'https://stores.jp/reserve/categories/hair_salons',
                    text: intl.formatMessage({
                      id: intlPref + 'links.hairsalons',
                    }),
                  },
                  {
                    url: 'https://stores.jp/reserve/categories/nail_salons',
                    text: intl.formatMessage({
                      id: intlPref + 'links.nailsalons',
                    }),
                  },
                  {
                    url: 'https://stores.jp/reserve/categories/spaces',
                    text: intl.formatMessage({
                      id: intlPref + 'links.spaces',
                    }),
                  },
                  {
                    url: 'https://stores.jp/reserve/categories/exhibitions',
                    text: intl.formatMessage({
                      id: intlPref + 'links.exhibitions',
                    }),
                  },
                  {
                    url: 'https://stores.jp/reserve/categories/lessons',
                    text: intl.formatMessage({
                      id: intlPref + 'links.classes',
                    }),
                  },
                  {
                    url: 'https://stores.jp/reserve/categories/seminar',
                    text: intl.formatMessage({
                      id: intlPref + 'links.seminar',
                    }),
                  },
                  {
                    url: 'https://stores.jp/reserve/categories/recruiting',
                    text: intl.formatMessage({
                      id: intlPref + 'links.recruiting',
                    }),
                  },
                  {
                    url: 'https://stores.jp/reserve/categories/communities',
                    text: intl.formatMessage({
                      id: intlPref + 'links.community',
                    }),
                  },
                  {
                    url: 'https://stores.jp/reserve/categories/events',
                    text: intl.formatMessage({
                      id: intlPref + 'links.events',
                    }),
                  },
                  {
                    url: 'https://stores.jp/reserve/categories/tourism',
                    text: intl.formatMessage({
                      id: intlPref + 'links.tourism',
                    }),
                  },
                  {
                    url: 'https://stores.jp/reserve/categories/experts',
                    text: intl.formatMessage({
                      id: intlPref + 'links.experts',
                    }),
                  },
                  {
                    url: 'https://stores.jp/reserve/categories/cooking_lessons',
                    text: intl.formatMessage({
                      id: intlPref + 'links.cooking_class',
                    }),
                  },
                  {
                    url: 'https://stores.jp/reserve/categories/golf_lessons',
                    text: intl.formatMessage({
                      id: intlPref + 'links.golf_lesson',
                    }),
                  },
                  {
                    url: 'https://stores.jp/reserve/categories/language_lessons',
                    text: intl.formatMessage({
                      id: intlPref + 'links.language_school',
                    }),
                  },
                  {
                    url: 'https://stores.jp/reserve/categories/pc_lessons',
                    text: intl.formatMessage({
                      id: intlPref + 'links.pc_class',
                    }),
                  },
                  {
                    url: 'https://stores.jp/reserve/categories/sports_lessons',
                    text: intl.formatMessage({
                      id: intlPref + 'links.sports_lesson',
                    }),
                  },
                  {
                    url: 'https://stores.jp/reserve/categories/others',
                    text: intl.formatMessage({
                      id: intlPref + 'links.other',
                    }),
                  },
                ],
              },
            ]}
          />
        </ServiceFooterAccordion>

        <ServiceFooterSingleHeadingAccordion
          className={css.ServiceFooter__ContentSection}
          name={'footer-company'}
          copy={intl.formatMessage({ id: intlPref + 'copies.company' })}
        >
          <ServiceFooterSectionBody
            rows={[
              {
                links: [
                  {
                    url: 'https://coubic.com/terms',
                    text: intl.formatMessage({
                      id: intlPref + 'links.terms',
                    }),
                  },
                  {
                    url: 'https://id.stores.jp/privacy_policy',
                    text: intl.formatMessage({
                      id: intlPref + 'links.policyForMerchant',
                    }),
                  },
                  {
                    url: 'https://stores.jp/reserve/privacy',
                    text: intl.formatMessage({
                      id: intlPref + 'links.policyForEndUser',
                    }),
                  },
                  {
                    url: 'https://coubic.com/legal_notice',
                    text: intl.formatMessage({
                      id: intlPref + 'links.sct',
                    }),
                  },
                ],
              },
            ]}
          />
        </ServiceFooterSingleHeadingAccordion>
        <div className={css.ServiceFooter__ContentSection}>
          <div className={css.ServiceFooter__Language}>
            <span>{intl.formatMessage({ id: intlPref + 'language' })}：</span>
            <select
              className={css.ServiceFooter__LanguageSelect}
              onChange={(e) => {
                localeCtx.changeLocale(e.target.value);
              }}
              value={localeCtx.currentLocale}
            >
              <option value="ja">日本語</option>
              <option value="en">English</option>
              <option value="ko">한국어</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ServiceFooter;
